import { Text, Box, HStack, VStack, Icon, Grid } from "@chakra-ui/react";
import { FaUser, FaCalendarAlt, FaEnvelope, FaPhone } from "react-icons/fa";

import { documentFormatter } from "@/utils/documentFormatter";
import { phoneFormatter } from "@/utils/formatPhone";
import { formatDateWithNoHours } from "@/utils/formatDateWithNoHours";

interface DataPerson {
  id: string;
  nome: string | null;
  cpf: string;
  data_nascimento: Date | null;
  idade: number | null;
  email?: string | null;
  telefone?: string | null;
  estado_civil?: string | null;
  nacionalidade?: string | null;
  genero?: string | null;
}

interface HeaderDataPersonProps {
  dataPerson: DataPerson;
}

export function HeaderDataPerson({ dataPerson }: HeaderDataPersonProps) {
  return (
    <Box
      bg="gray.50"
      borderRadius="md"
      p={4}
      border="1px solid"
      borderColor="gray.200"
      flexShrink={0}
    >
      <Grid templateColumns="1fr 1fr" gap={4}>
        {/* Coluna 1: Nome e Email */}
        <VStack align="flex-start" spacing={2}>
          <HStack spacing={2} align="flex-start">
            <VStack align="flex-start" spacing={2}>
              <HStack spacing={2} align="flex-start">
                <Icon
                  as={FaUser}
                  color="secondary"
                  boxSize={4}
                  flexShrink={0}
                  mt={0.5}
                />
                <Text fontSize="md" fontWeight="bold" color="gray.700">
                  {dataPerson.nome || "Não informado"}
                </Text>
              </HStack>
              {dataPerson.email && (
                <HStack spacing={1.5}>
                  <Icon
                    as={FaEnvelope}
                    color="gray.500"
                    boxSize={3}
                    flexShrink={0}
                  />
                  <Text fontSize="xs" color="gray.600" isTruncated maxW="100%">
                    {dataPerson.email}
                  </Text>
                </HStack>
              )}
            </VStack>
          </HStack>
        </VStack>

        {/* Coluna 2: Dividida em duas sub-colunas */}
        <Grid templateColumns="1fr 1fr" gap={3}>
          {/* Sub-coluna 1: CPF e Data de Nascimento */}
          <VStack align="flex-start" spacing={2}>
            <HStack spacing={1}>
              <Text fontSize="xs" color="gray.500" fontWeight="semibold">
                CPF:
              </Text>
              <Text fontSize="xs" color="gray.600">
                {documentFormatter(dataPerson.cpf)}
              </Text>
            </HStack>

            {dataPerson.data_nascimento && (
              <HStack spacing={1}>
                <Icon as={FaCalendarAlt} color="gray.500" boxSize={3} />
                <Text fontSize="xs" color="gray.600">
                  {formatDateWithNoHours(dataPerson.data_nascimento.toString())}
                  {dataPerson.idade && ` (${dataPerson.idade} anos)`}
                </Text>
              </HStack>
            )}
          </VStack>

          {/* Sub-coluna 2: Telefone e Gênero */}
          <VStack align="flex-start" spacing={2}>
            {dataPerson.telefone && (
              <HStack spacing={1}>
                <Icon as={FaPhone} color="gray.500" boxSize={3} />
                <Text fontSize="xs" color="gray.600">
                  {phoneFormatter(dataPerson.telefone)}
                </Text>
              </HStack>
            )}

            {dataPerson.genero && (
              <HStack spacing={1}>
                <Icon as={FaUser} color="gray.500" boxSize={3} />
                <Text fontSize="xs" color="gray.600">
                  {dataPerson.genero}
                </Text>
              </HStack>
            )}
          </VStack>
        </Grid>
      </Grid>
    </Box>
  );
}
